(function () {
        'use strict';

        angular.module('app.charts')
            .directive('serialChart', serialChart);

        /* @ngInject */
        function serialChart(SETTINGS, DataFactory, $rootScope) {
            return {
                restrict: 'E',
                templateUrl: '/views/charts/serial.html',
                scope: {
                    id: '@',
	                chartDataKey: '@',
	                filter: '=',
                    unit: '@',
                    unitPosition: '@',
	                subtitle: '=',
                    yLabel: '=',
                    title: '@',
                    smooth: '@',
	                exportDimensions: '@',
					legendPosition: "@",
					logoUrl: '@',
                    bullets: '@',
                    maxValue: "=",
                    bannerImage: '@',
					legendLabelWidth: '=',
                    markers: '='
                },
                link: link
            };

            function link(scope, elm) {

                var chart,
                    hiddenChart,
                    hiddenID = scope.id + '_hidden',
                    exportW = 800,
					smooth = false,
					bullets = true,
                    exportH = 600,
					masterData,
					filter,
					legendPosition = 'right',
                    legendAlign = '',
					filteredData,
                    maxValue = 100,
                    markers = [],
                    markerSize = 16,
                    unit = '',
                    unitPosition = '',
                    source = SETTINGS.CHARTS.SOURCE
				;

                elm.append('<div class="chart-hidden" id="' + hiddenID + '"></div>');
				
				if (angular.isDefined(scope.smooth)) {
					smooth = scope.smooth;
				}

                if (angular.isDefined(scope.unit)) {
                    unit = scope.unit;

                    if (unit === '$' && unitPosition === '') {
                        unitPosition = 'left';
                    }
                }

				if (angular.isDefined(scope.bullets)) {
					bullets = scope.bullets === true || scope.bullets === "true";
				}

	            if (angular.isDefined(scope.legendPosition)) {
					legendPosition = scope.legendPosition;
					
					if (legendPosition === 'bottom' && legendAlign === '') {
					    legendAlign = 'center';
                    }
	            }

                if (angular.isDefined(scope.maxValue)) {
                    maxValue = scope.maxValue;
                }

	            if (angular.isDefined(scope.exportDimensions)) {
					var dimensions = scope.exportDimensions.split('x');
					if (angular.isArray(dimensions) && dimensions.length === 2) {
						exportW = Number(dimensions[0]);
						exportH = Number(dimensions[1]);
					}
	            } else if (elm.hasClass('tall')) {
	            	exportH = 1000;
	            } else if (elm.hasClass('xtall')) {
	            	exportH = 1400;
	            }

                if (angular.isArray(scope.markers)) {
                    markers = scope.markers;
                    markerSize = 50;
                }

				function dataChanged(){
	                if (masterData && masterData.data !== undefined) {
						if (angular.isDefined(filter) && filter !== null && filter !== '') {
							filteredData = masterData.data[filter];
						} else {
							filteredData = masterData.data;
						}
						if (angular.isArray(filteredData)) {
		                    if (chart === undefined) {
		                        render();
		                    }
		                    chart.dataProvider = filteredData;
		                    chart.validateData();
	                        angular.forEach(chart.valueAxes, function (va) {
	                            va.unit = unit;
	                            va.unitPosition = unitPosition;
	                            va.title = scope.yLabel;
	                        });
						}

						// footer
                        scope.footer = DataFactory.getSamplesString(masterData, filter);
	                }
				}
			
				if (angular.isDefined(scope.chartDataKey)) {
					DataFactory.getJSON(scope.chartDataKey).then(function(response) {
						masterData = response;
						DataFactory.injectSampleInfo(masterData);
						dataChanged();
					});

		            if (angular.isDefined(scope.filter)) {
						filter = scope.filter;
			            scope.$watch('filter', function(newVal){
			            	filter = newVal;
							dataChanged();
			            });
		            } else {
		            	filter = $rootScope.dataFilterSelected.value;	
			            $rootScope.$watch('dataFilterSelected', function(newVal){
			            	filter = newVal.value;
							dataChanged();
			            });
		            }
				}

                function render() {

                    var config = {
                        "type": "serial",
                        "sequencedAnimation": false,
                        "categoryField": "Category",
                        "colors": SETTINGS.PALETTE,
                        "startDuration": .4,
                        "categoryAxis": {
                            "gridPosition": "start",
                            "title": "",
                            "titleFontSize": 0,
                            "axisColor": "#E5E5E5",
                            "color": SETTINGS.CHARTS.TEXT.COLOR,
                            "labelRotation": 45
                        },
                        "chartCursor": {
                            "enabled": true,
                            "animationDuration": 0.3,
                            "color": "#000000",
                            "cursorColor": "#E5E5E5",
                            "fullWidth": true
                        },
                        "graphs": graphs(),
                        "valueAxes": [
                            {
                                "gridThickness": 0,
                                "title": scope.yLabel,
                                "unit": scope.unit,
                                "axisColor": "#E5E5E5",
                                "color": SETTINGS.CHARTS.TEXT.COLOR,
                                // "minimum": 0,
                                // "maximum": maxValue
                            }
                        ],
                        "titles": [],
                        "legend": {
                            "enabled": true,
                            "useGraphSettings": markers.length === 0,
                            "position": legendPosition,
                            "align": legendAlign,
                            "color": SETTINGS.CHARTS.TEXT.COLOR,
                            "fontSize": 12,
                            "markerSize": markerSize,
                            "equalWidths": true,
							"labelWidth": scope.legendLabelWidth,
                        },
                        "dataProvider": []
                    };

                    chart = AmCharts.makeChart(scope.id + "_chart", config, 100);

                    function graphs() {

                        var graphs = [];

						if (masterData && angular.isDefined(masterData.meta) && angular.isArray(masterData.meta.series)) {
		                    angular.forEach(masterData.meta.series, function (series, i) {
	                            graphs.push({
	                                "bullet": bullets ? "round" : null,
									"type": smooth ? "smoothedLine" : "line",
	                                "lineThickness": 3,
	                                "title": series,
									"balloonFunction": function(item, graph) {
                                        var result = graph.balloonText;
                                        if (!isNaN(item.dataContext[series])) {
                                            var formatted = AmCharts.formatNumber(item.dataContext[series], {
                                                precision: chart.precision,
                                                decimalSeparator: chart.decimalSeparator,
                                                thousandsSeparator: chart.thousandsSeparator
                                            }, 0);
                                            result = result.replace('[[value]]', formatted);

                                            if (unit !== '') {
                                                if (unitPosition === 'left') {
                                                    result = unit + result;
                                                } else {
                                                    result = result + unit;
                                                }
                                            }
                                        }
                                        return graph.title + ': ' + result;
                                    },
	                                "valueField": series,
                                    "customMarker": markers.length > i ? 'assets/images/icons/' + markers[i] : ''
	                            });
	                        });
						}

                        return graphs;
                    }

                    function exportChart() {

                        var exportConfig = {};

                        var hiddenDiv = angular.element(document.getElementById(hiddenID));
                        hiddenDiv.css({
                            width: exportW + 'px',
                            height: exportH + 'px'
                        });

                        // Copy visible chart config
                        angular.copy(config, exportConfig);

                        exportConfig.autoMargins = false;
                        exportConfig.marginLeft = 100;
                        exportConfig.marginTop = 50;
                        exportConfig.marginBottom = 100;

                        // Update data
                        exportConfig.dataProvider = filteredData;

                        if (angular.isDefined(scope.title)) {
                            exportConfig.marginTop += 50;
                        }

	                    if (angular.isDefined(scope.subtitle)) {
	                        exportConfig.marginTop += 30;
	                    }

						if (exportConfig.legend.position === 'bottom') {
							exportConfig.legend.autoMargins = false;
							exportConfig.legend.marginBottom = 70;
						} else {
		                    if (angular.isDefined(scope.footer)) {
		                        exportConfig.marginBottom += 50;
		                    }
						}

                        exportConfig.export = {
                            enabled: true,
                            libs: {
                                autoLoad: false
                            },
                            menu: [],
                            afterCapture: function () {
                                var instance = this;

                                // Logo
                                var imgEl = document.querySelector('#chart-header-img');

                                if (imgEl !== null) {
                                    var logo = new fabric.Image(imgEl, {
                                        left: exportW - imgEl.width,
                                        top: 20
                                    });
                                    instance.setup.fabric.add(logo);
                                }

                                // Title
                                if (angular.isDefined(scope.title)) {
                                    var title = new fabric.Text(scope.title.toUpperCase(), {
                                        left: 30,
                                        top: 50,
                                        fontFamily: SETTINGS.FONT_FAMILY,
                                        fontSize: 18
                                    });
									title.left = exportW/2 - title.width/2;
                                    instance.setup.fabric.add(title);
                                }

                                // subtitle
	                            if (angular.isDefined(scope.subtitle)) {
	                                var subtitle = new fabric.Text(scope.subtitle, {
	                                    left: 30,
	                                    top: 80,
	                                    fontFamily: SETTINGS.FONT_FAMILY,
	                                    fontSize: 15
	                                });
									subtitle.left = exportW/2 - subtitle.width/2;
	                                instance.setup.fabric.add(subtitle);
	                            }

	                            // footer
	                            if (scope.footer) {
	                                var footer = new fabric.Text(scope.footer, {
	                                    left: 30,
                                        top: exportH - 50,
	                                    fontFamily: SETTINGS.FONT_FAMILY,
	                                    fontSize: 10
	                                });
	                                instance.setup.fabric.add(footer);
	                            }

	                            // Source
	                            var src = new fabric.Text('Source: ' + source, {
	                                left: 30,
	                                top: exportH - 40,
	                                fontFamily: SETTINGS.FONT_FAMILY,
	                                fontSize: 10
	                            });
	                            instance.setup.fabric.add(src);
                            }
                        };

                        hiddenChart = AmCharts.makeChart(hiddenID, exportConfig);

                        hiddenChart.export.capture({}, function () {
                            this.toPNG({}, function (data) {
                                this.download(data, this.defaults.formats.PNG.mimeType, scope.title);
                            });
                        });
                    }

                    scope.exportChart = exportChart;
                }
            }
        }
    })();